import React from 'react'

import SignInForm from '../components/SignInForm.jsx'

const Signin = () => {
  return (
    <div>
      <SignInForm />
    </div>
  )
}

export default Signin
